import Heading from "hardcover-ui/components/Heading";
import Text from "hardcover-ui/components/Text";
import TextLink from "hardcover-ui/components/TextLink";
import pluralize from "lib/pluralize";
import Badge from "hardcover-ui/components/Badge";
import AboutSeries from "components/series/AboutSeries";
import { BookGroupSizeType, SeriesContextType } from "../types";
import BookGroupHeaderWrapper from "./parts/BookGroupHeaderWrapper";
import LocaleNumber from "components/ui/LocaleNumber";

export default function SeriesHeader({
  context,
  size,
}: {
  context: SeriesContextType;
  size: BookGroupSizeType;
}) {
  const { series } = context;

  return (
    <BookGroupHeaderWrapper size={size}>
      <div className="flex flex-row space-x-2 mb-1">
        <Text variant="secondary" as="p" size="sm" className="font-semibold">
          {size === "lg" ? <span>Featured </span> : false}
          Series
        </Text>
        {series.primaryBooksCount > 0 ? (
          <>
            <Badge size="sm" variant={size === "lg" ? "accent" : "secondary"}>
              <LocaleNumber number={series.primaryBooksCount} />{" "}
              {pluralize("primary book", series.primaryBooksCount)}
            </Badge>
            {series.primaryBooksCount !== series.releasedBooksCount && (
              <Badge size="sm" variant="secondary">
                <LocaleNumber number={series.releasedBooksCount} />{" "}
                {pluralize("released book", series.releasedBooksCount)}
              </Badge>
            )}
          </>
        ) : (
          <Badge size="sm" variant="secondary">
            {series.releasedBooksCount.toLocaleString()}{" "}
            {pluralize("released book", series.releasedBooksCount)}
          </Badge>
        )}
      </div>
      <Heading level={3} size={size === "lg" ? "md" : "sm"} className="mb-2">
        <TextLink href={`/series/${context.series.slug}`} underline={false}>
          <>{series.name}</>
        </TextLink>
      </Heading>
      <AboutSeries series={series} />
    </BookGroupHeaderWrapper>
  );
}
